// @ts-nocheck
import * as React from "react";

const CartPlusFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.167 9.754V6.86H9.272v-.965h2.895V3h.965v2.895h2.894v.965h-2.894v2.894h-.965ZM8.122 21.927c-.407 0-.75-.139-1.03-.418a1.4 1.4 0 0 1-.418-1.029c0-.407.14-.75.418-1.029a1.4 1.4 0 0 1 1.03-.418c.407 0 .75.14 1.028.418.28.279.419.622.419 1.03 0 .406-.14.749-.419 1.028a1.398 1.398 0 0 1-1.028.418Zm9.055 0c-.407 0-.75-.139-1.029-.418a1.398 1.398 0 0 1-.418-1.029c0-.407.139-.75.418-1.029a1.398 1.398 0 0 1 1.029-.418c.407 0 .75.14 1.029.418a1.4 1.4 0 0 1 .418 1.03c0 .406-.14.749-.418 1.028a1.399 1.399 0 0 1-1.03.418ZM3 4.93v-.965h2.362l3.953 8.313h6.754l3.54-6.383h1.101l-4.077 7.348H8.886l-1.581 2.895h11.32v.965H5.644l2.647-4.728L4.744 4.93H3Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(CartPlusFill);
